import type { CircleLayerSpecification, ExpressionSpecification } from 'maplibre-gl';

/**
 * Points de l'historique de positions (un par trame) : style de la couche circle.
 * Petits à l'échelle d'un site (zoom 19-20, 1 Hz) : 8,5 px de diamètre au plus, sinon ils se
 * recouvrent et cachent la trajectoire (retour d'Eddy du 2026-10-05).
 */
export const HISTORY_POINTS_PAINT: CircleLayerSpecification['paint'] & {
  'circle-radius': ExpressionSpecification;
  'circle-stroke-width': number;
} = {
  'circle-radius': ['interpolate', ['linear'], ['zoom'], 12, 1.5, 17, 2.5, 20, 3.5],
  'circle-color': ['get', 'color'],
  'circle-stroke-color': '#ffffff',
  'circle-stroke-width': 0.75,
  'circle-stroke-opacity': 0.8,
};
